import { render, staticRenderFns } from "./AggreMain.vue?vue&type=template&id=3b6ed9d1"
import script from "./AggreMain.vue?vue&type=script&lang=js"
export * from "./AggreMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports